import { Slide } from "react-reveal";

const ICTTrainingOffers = () => {
  return (
    <section className="solution-item-section section-spacing-50 world-bg">
      <div className="container">
        <div className="large">
          <div className="section-content-container">
            <div className="solution-offers-container flex">
              <div className="solution-offers-textside">
                <div className="section-head width-600 section-spacing-40 no-padding-top">
                  <p className="section-tag boldTitle">OFFERS</p>
                  <Slide top>
                    <h2 className="section-title ntuna-text-fill">
                      What's Included
                    </h2>
                  </Slide>
                  <p className="section-subtitle font-inter-regular">
                    Education, packaged for real life. Move away from
                    traditional, rigid learning systems and focus on what truly
                    matters for today's era - practical skills that can be
                    applied immediately in the real world and start earning as
                    soon as possible.
                  </p>
                </div>
                <div className="section-body">
                  <ul className="offers-list-container">
                    <li className="offers-list">
                      <h3>
                        Structured Learning Journey (Bronze &rarr;Platinum)
                      </h3>
                      <ul>
                        <li>
                          <span>Guided entry point based on your level</span>
                        </li>
                        <li>
                          <span>Progressive skill-building across levels</span>
                        </li>
                        <li>
                          <span>
                            Step-by-step progression with no confusion
                          </span>
                        </li>
                        <li>
                          <span>
                            Defined milestones and outcomes at each level
                          </span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>
                        Practical ICT Foundations(Real-world digital
                        literacy){" "}
                      </h3>
                      <ul>
                        <li>
                          <span>Computer fundamentals</span>
                        </li>
                        <li>
                          <span>Computer usage basics, tricks & hacks</span>
                        </li>
                        <li>
                          <span>Internet usage & digital workflows</span>
                        </li>
                        <li>
                          <span>File management & productivity habits</span>
                        </li>
                        <li>
                          <span>
                            Essential workplace tools (Word, Excel, Powerpoint,
                            etc)
                          </span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>
                        AI & Modern Digital Skills (Future-ready capability)
                      </h3>
                      <ul>
                        <li>
                          <span>Introduction to AI tools & platforms</span>
                        </li>
                        <li>
                          <span>
                            Practical AI use for work, business & productivity
                          </span>
                        </li>
                        <li>
                          <span>
                            Automation basics and efficiency workflows
                          </span>
                        </li>
                        <li>
                          <span>Using AI for efficiency</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>
                        Career Path Specialization Tracks(Gold & Platinum
                        Levels)
                      </h3>
                      <ul>
                        <li>
                          <span>Selection of career path</span>
                        </li>
                        <li>
                          <span>
                            Deep, structured learning in your chosen ICT field
                          </span>
                        </li>
                        <li>
                          <span>Role-specific skill development</span>
                        </li>
                        <li>
                          <span>Alignment with real-world demand</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Hands-on Project-based Learning </h3>
                      <ul>
                        <li>
                          <span>Real-world assignments</span>
                        </li>
                        <li>
                          <span>Practical exercises</span>
                        </li>
                        <li>
                          <span>Guided implementaion tasks</span>
                        </li>
                        <li>
                          <span>Portfolio-building projects</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Portfolio, Execution & Output Development</h3>
                      <ul>
                        <li>
                          <span>Creation of real projects</span>
                        </li>
                        <li>
                          <span>Documented work & outputs</span>
                        </li>
                        <li>
                          <span>Practical demonstrations of ability</span>
                        </li>
                        <li>
                          <span>
                            Readiness for clients, employers or business{" "}
                          </span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Income & Career Readiness System</h3>
                      <ul>
                        <li>
                          <span>Understanding how to monitize skills</span>
                        </li>
                        <li>
                          <span>Exposure to real opportunities</span>
                        </li>
                        <li>
                          <span>Practical guidance on earning pathways</span>
                        </li>
                        <li>
                          <span>Career direction clarity</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Real-world Tools & Equipment Exposure</h3>
                      <ul>
                        <li>
                          <span>Hands-on interaction with ICT tools</span>
                        </li>
                        <li>
                          <span>Exposure to real working environments</span>
                        </li>
                        <li>
                          <span>
                            Familiarity with industry tools and systems
                          </span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Systems & Software Usage Training</h3>
                      <ul>
                        <li>
                          <span>Business tools & platforms</span>
                        </li>
                        <li>
                          <span>Cloud-based systems</span>
                        </li>
                        <li>
                          <span>Digital workflows & integrations</span>
                        </li>
                        <li>
                          <span>Tool-based productivity systems</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Flexible Learning Model (Online + Physical)</h3>
                      <ul>
                        <li>
                          <span>Physical classes</span>
                        </li>
                        <li>
                          <span>Online attendance</span>
                        </li>
                        <li>
                          <span>Hybrid flexibility</span>
                        </li>
                        <li>
                          <span>Continous access to learning</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Learning From Real-world Practitioners</h3>
                      <ul>
                        <li>
                          <span>Active industry professionals</span>
                        </li>
                        <li>
                          <span>Entreprenuers & builders</span>
                        </li>
                        <li>
                          <span>Real-world experience sharing</span>
                        </li>
                        <li>
                          <span>Practical insights & workflows</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Personalized Learning Path & Goal Alignment</h3>
                      <ul>
                        <li>
                          <span>Package selection based on goals</span>
                        </li>
                        <li>
                          <span>Career direction alignment</span>
                        </li>
                        <li>
                          <span>Guided progression</span>
                        </li>
                        <li>
                          <span>Flexible advancement</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Continous Learning & Skill Progression</h3>
                      <ul>
                        <li>
                          <span>Advancement through packages</span>
                        </li>
                        <li>
                          <span>Skill reinforcement</span>
                        </li>
                        <li>
                          <span>Ongoing improvement pathways</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Corporate & Institution Capacity Building</h3>
                      <ul>
                        <li>
                          <span>Staff ICT training programs</span>
                        </li>
                        <li>
                          <span>Custom learning solutions</span>
                        </li>
                        <li>
                          <span>Organizational skill development</span>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ICTTrainingOffers;
